import { useReducer } from "react";
import { Link, useLocation } from "react-router-dom";
import LinkBtn from "../LinkBtn/LinkBtn";
import { FaHome, FaUser, FaEnvelope, FaBriefcase } from "react-icons/fa";

const icons = {
  home: FaHome,
  about: FaUser,
  work: FaBriefcase,
  contact: FaEnvelope,
};

const links = [
  { id: "home", to: "/", text: "Home" },
  { id: "about", to: "/about", text: "About" },
  { id: "work", to: "/work", text: "Work" },
  { id: "contact", to: "/contact", text: "Contact" },
];

//set the active link
const pathMap = {
  "/": "home",
  "/about": "about",
  "/work": "work",
  "/contact": "contact",
};

const reducer = (state, action) => {
  switch (action.type) {
    case "hover":
      return { ...state, [action.id]: true };
    case "unhover":
      return { ...state, [action.id]: false };

    default:
      return state;
  }
};

export default function Navbar() {
  const [hovered, dispatch] = useReducer(reducer, {
    home: false,
    about: false,
    work: false,
    contact: false,
    active: null,
  });

  const { pathname } = useLocation();
  const activeLink = pathMap[pathname] ?? null;

  return (
    <div className="flex-col items-center hidden md:flex">
      {links.map(({ id, to, text }) => {
        const Icon = icons[id];
        const isActive = activeLink === id;
        const isHovered = hovered[id];
        return (
          <Link
            key={id}
            to={to}
            className={`flex relative items-center justify-center gap-10 cursor-pointer p-5 ${
              isHovered ? "linkHover" : ""
            } ${isActive ? "activeLink" : ""}`}
            onMouseEnter={() => dispatch({ type: "hover", id: id })}
            onMouseLeave={() => dispatch({ type: "unhover", id: id })}
          >
            <div className="flex gap-2 flex-col items-center">
              <Icon
                className={`text-2xl ${
                  isActive ? "text-[#b87333]" : "text-[#98948f]"
                }`}
              />
              <p
                className={`text-xs ${
                  isActive ? "text-[#b87333]" : "text-[#98948f]"
                }`}
              >
                {text}
              </p>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
